import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorCors,
  fetchProcessorCorsAttributes,
  fetchProcessorCorsById,
  updateProcessorCors,
  updateStatusInProcessorCors,
} from "./thunk";

interface CategoryState {
  processor_cors_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_cors_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "processor_cors",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorCorsAttributes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorCorsAttributes.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_cors_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorCorsAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch processor_cors";
      })
      .addCase(fetchProcessorCorsById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorCorsById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorCorsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorCors.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_cors_list = state.processor_cors_list.map((processor_cors) =>
          processor_cors.id === action.payload.id ? action.payload : processor_cors
        );
      })
      .addCase(addProcessorCors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateProcessorCors.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_cors_list = state.processor_cors_list.map((processor_cors) =>
          processor_cors.id === action.payload.id ? action.payload : processor_cors
        );
      })
      .addCase(updateProcessorCors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInProcessorCors.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInProcessorCors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
